module.exports = __webpack_public_path__ + "static/media/ic-desk.ce18a0cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-desk.svg
// module id = 618
// module chunks = 14